import React from "react";
import { withObjectiveContainer } from "../../containers/gamification";
import EmptyStateLayout from "../shared/EmptyStateLayout";
import { ReactComponent as NoGoal } from "../../../assets/img/No_Goal.svg";
import ObjectivesList from "./ObjectivesList";
import { t } from "../../../i18n";

const Objectives = (props) => {
  const { objectives, ...rest } = props;

  const message = t("gamification2026.objectives.no-results");
  return (
    <div className="objectives">
      <h4 className="objectives-title">Objetivos</h4>
      {objectives.length > 0 ? (
        <ObjectivesList
          currencyLabel={props.client.currency_label}
          objectives={objectives}
          {...rest}
        />
      ) : (
        <EmptyStateLayout message={message}>
          <div className="gl-no-store">
            <NoGoal className="mr-3 dead-grey gl-no-store__image" />
          </div>
        </EmptyStateLayout>
      )}
    </div>
  );
};

export default withObjectiveContainer(Objectives);
